const MODAL_ROOT = "line-spacing-modal";
const TOOLBAR_BUTTON = "LineSpacingButton";
const PREDEFINED_SPACING_OPTION = "predefined-spacing-option";

export { MODAL_ROOT, PREDEFINED_SPACING_OPTION, TOOLBAR_BUTTON };
//# sourceMappingURL=data-hooks.js.map
